/******************************************************************************
 * 
 * Strauss Motion
 * 
 * Copyright (c) 2022 Robimo GmbH
 *
 * Authors: Daniel Martinek
 *
 *****************************************************************************/

import { connect } from 'react-redux'
import { ApplicationState, CountryData } from '../store/interfaces';

import { Customerscreen } from '../components/Customerscreen'
import { configSendFetch, configSetAddress, configSetCity, configSetComment, configSetCountry, configSetCustomerNumber, configSetEmail, configSetFirstName, configSetLastName, configSetOccupation, configSetOrderFor, configSetPhone, configSetTitle, configSetZipCode, uiGoTo, uiSetCountry, uiSetMobileOrderStep, uiSetVat, uiShowCountryChangeInfo } from '../store/actions';

const mapStateToProps = (state: ApplicationState) => {
    return {
        ui: state.ui,
        config: state.config,
        contact: state.contact,
        library: state.library
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        onUiGoTo: (route: string) => {
            dispatch(uiGoTo(route));
        },
        onUiSetMobileOrderStep: (step: string) => {
            dispatch(uiSetMobileOrderStep(step));
        },
        onConfigSetOrderFor: (value: string) => {
            dispatch(configSetOrderFor(value));
        },
        onConfigSetCustomerNumber: (value: string) => {
            dispatch(configSetCustomerNumber(value));
        },
        onConfigSetFirstName: (value: string) => {
            dispatch(configSetFirstName(value));
        },
        onConfigSetLastName: (value: string) => {
            dispatch(configSetLastName(value));
        },
        onConfigSetCountry: (value: string) => {
            dispatch(configSetCountry(value));
        },
        onConfigSetZipCode: (value: string) => {
            dispatch(configSetZipCode(value));
        },
        onConfigSetCity: (value: string) => {
            dispatch(configSetCity(value));
        },
        onConfigSetAddress: (value: string) => {
            dispatch(configSetAddress(value));
        },
        onConfigSetTitle: (value: string) => {
            dispatch(configSetTitle(value));
        },
        onConfigSetOccupation: (value: string) => {
            dispatch(configSetOccupation(value));
        },
        onConfigSetEmail: (value: string) => {
            dispatch(configSetEmail(value));
        },
        onConfigSetPhone: (value: string) => {
            dispatch(configSetPhone(value));
        },
        onConfigSetComment: (value: string) => {
            dispatch(configSetComment(value));
        },
        onConfigSend: (lang: string) => {
            dispatch(configSendFetch(lang));
        },
        onUISetVat: (vat: boolean) => {
            dispatch(uiSetVat(vat));
        },
        onUiSetCountry: (country: CountryData) => {
            dispatch(uiSetCountry(country));
        },
        onUiShowCountryChangeInfo: (showCountryChangeInfo: boolean) => {
            dispatch(uiShowCountryChangeInfo(showCountryChangeInfo));
        }
    }
}

const CustomerscreenContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Customerscreen)

export default CustomerscreenContainer